export default "__VITE_ASSET__Cu1pEc9I__"